var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomModule8(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 8.42315V18.4232C22 18.9332 21.7974 19.4223 21.4367 19.783C21.0761 20.1436 20.587 20.3462 20.0769 20.3462M20.0769 20.3462C19.5669 20.3462 19.0777 20.1436 18.7171 19.783C18.3565 19.4223 18.1538 18.9332 18.1538 18.4232V4.96161C18.1538 4.7576 18.0728 4.56194 17.9285 4.41769C17.7843 4.27343 17.5886 4.19238 17.3846 4.19238H2.76923C2.56522 4.19238 2.36956 4.27343 2.2253 4.41769C2.08104 4.56194 2 4.7576 2 4.96161V18.8078C2 19.2158 2.16209 19.6071 2.4506 19.8956C2.73912 20.1841 3.13044 20.3462 3.53846 20.3462H20.0769ZM6.61542 16.5001H13.5385M13.5385 8.03857H6.61542V11.8847H13.5385V8.03857Z",
    stroke: "#192048",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomModule8);
export default __webpack_public_path__ + "static/media/CustomModule8.707071d5e59692b476cb4e080947fc29.svg";
export { ForwardRef as ReactComponent };